export default "__VITE_ASSET__BGwa_fx___"